const getRelatedActivity = (activity, sequence) => {
  const deliveryId = activity.delivery_order.id

  let _activity = null

  // TODO: Find another way to get related activity
  // instead of looping through all sequence,
  // possibly attach related activity id inside from backend
  for (let point of sequence) {
    if (_activity) break
    if (!point.activities) continue

    for (let activity of point.activities) {
      if (activity.delivery_order.id === deliveryId) {
        _activity = activity
        break
      }
    }
  }

  return _activity
}

export default getRelatedActivity
